import React, { Component } from 'react';
import { Card, Table, Modal, Button, Popover, Spin, Checkbox } from 'antd';
import './MaintenanceCard.css';
import { inject, observer } from 'mobx-react';

import AirIcon from '../../../../../common/icons/AirIcon';
import leadsHelper from '../../../../../helpers/leadsHelper';

import moment from 'moment';
import { api } from '../../../../../services';
import { pick } from 'lodash';
import NewMaintenanceModal from '../../../../../common/components/NewMaintenanceModal';

@inject('translationsStore', 'commonStore')
@observer
export default class MaintenanceCard extends Component {
  constructor(props) {
    super(props);
    const { translationsStore, commonStore } = props;
    this.columns = [
      {
        dataIndex: 'id',
        title: translationsStore.translate('carView.MaintenanceCard.column.maintenance'),
        render: (text, record) => <span>{translationsStore.translate(`carView.MaintenanceCard.type.${record.type}`)}</span>
      },
      {
        dataIndex: 'km',
        align: 'center',
        title: translationsStore.translate('carView.MaintenanceCard.column.scheduledKm'),
        render: text => <span>{text ? Number(text).toLocaleString() : '-'}</span>
      },
      {
        dataIndex: 'date',
        align: 'center',
        title: translationsStore.translate('carView.MaintenanceCard.column.scheduledDate'),
        render: (text, record) => <span>{record.date ? moment(record.date).format(commonStore.longDateFormat.L) : '-'}</span>
      },
      {
        dataIndex: 'mileage',
        align: 'center',
        title: translationsStore.translate('carView.MaintenanceCard.column.mileage'),
        render: text => <span>{text && text.toLocaleString()}</span>
      },
      {
        dataIndex: 'kmLeft',
        align: 'center',
        title: translationsStore.translate('carView.MaintenanceCard.column.kmLeft'),
        render: (text, record) => <span>{record.mileage && record.km ? (record.km - record.mileage).toLocaleString() : <span>&mdash;</span>}</span>
      },
      {
        dataIndex: 'virtualDate',
        align: 'center',
        title: translationsStore.translate('carView.MaintenanceCard.column.daysLeft'),
        render: (text, record) => (
          <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', fontWeight: 'bold' }}>
            {!!record.virtualDate && <AirIcon type="tagliando" style={{ color: leadsHelper.maintenanceColor(moment().diff(moment(record.virtualDate, 'YYYY-MM-DD'), 'days')) }} />}
            {!!record.virtualDate && moment().diff(moment(record.virtualDate, 'YYYY-MM-DD'), 'days')}
          </div>
        )
      },
      {
        dataIndex: 'manage',
        align: 'center',
        title: translationsStore.translate('carView.MaintenanceCard.column.manage'),
        render: (text, record) => (
          <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', fontWeight: 'bold' }}>
            <span>
              <Button
                type="primary"
                size="small"
                className="confirm"
                onClick={() => {
                  this.setState({ showManageModal: true, selectedMaintenance: record.id });
                }}
              >
                {translationsStore.translate('carView.MaintenanceCard.column.manage')}
              </Button>
            </span>
          </div>
        )
      }
    ];

    this.historyTableColumns = [
      {
        dataIndex: 'type',
        title: this.props.translationsStore.translate('carView.MaintenanceCard.history.table.columns.type'),
        sorter: true,
        sortOrder: false,
        render: text => this.props.translationsStore.translate(`carView.MaintenanceCard.type.${text}`)
      },
      {
        dataIndex: 'date',
        title: this.props.translationsStore.translate('carView.MaintenanceCard.history.table.columns.scheduledDate'),
        sorter: true,
        sortOrder: false,
        width: 120,
        align: 'center',
        render: text => text ? moment(text).format(commonStore.longDateFormat.L) : '-'
      },
      {
        dataIndex: 'km',
        title: this.props.translationsStore.translate('carView.MaintenanceCard.history.table.columns.scheduledKm'),
        sorter: true,
        sortOrder: false,
        width: 80,
        align: 'center',
        render: text => text ? Number(text).toLocaleString() : '-'
      },
      {
        dataIndex: 'updatedAt',
        title: this.props.translationsStore.translate('carView.MaintenanceCard.history.table.columns.closedDate'),
        sorter: true,
        sortOrder: false,
        width: 120,
        render: text => `${moment(text).format(commonStore.longDateFormat.L)} ${moment(text).format(commonStore.longDateFormat.LT)}`
      }
    ];
    this.historyFetchMethods = [
      {
        key: 'maintenances',
        method: 'getMaintenancesCarHistory',
        defaultSorter: { field: 'updatedAt', order: 'DESC' }
      }
    ];

    this.defaultAddValues = {
      description: '',
      km: '',
      moment: null,
      date: ''
    };

    this.state = {
      sorters: { maintenances: this.historyFetchMethods[0].defaultSorter },
      showModalAdd: false,
      showModalAddInManage: false,
      modalAddLoading: false,
      modalCanAdd: false,
      modalAddDescription: this.defaultAddValues.description,
      modalAddKm: this.defaultAddValues.km,
      modalAddMoment: this.defaultAddValues.moment,
      modalAddDate: this.defaultAddValues.date
    };
  }

  loadHistory = (methods = ['maintenances'], page = 1) => {
    this.setState({
      historyLoading: true
    });
    const { carId } = this.props;
    const { sorters } = this.state;
    Promise.all(
      methods.map(method => {
        const { field: sort, order } = sorters[method];
        return api(this.historyFetchMethods.find(helper => helper.key === method).method, carId, page, sort, order);
      })
    ).then(methodsResponse => {
      const historySum = !!this.state.historySum
        ? this.state.historySum
        : methods.reduce((accumulator, method, index) => {
            return accumulator + methodsResponse[index].count;
          }, 0);
      let computedResources = methodsResponse.map((response, index) => ({
        key: methods[index],
        count: response.count,
        page,
        dataSource: response.rows.map((row, index) => ({
          ...row,
          key: index
        })),
        pagination: { total: response.count, current: page }
      }));
      let definedResources = this.state.historyResources;
      if (definedResources) {
        definedResources = definedResources.map(item => {
          const resource = computedResources.find(resource => resource.key === item.key);
          return resource ? resource : item;
        });
      } else {
        definedResources = computedResources;
      }

      const historyActiveKey = definedResources.reduce((accumulator, currentValue) => {
        return accumulator === null && methods.findIndex(method => method === currentValue.key) > -1 && currentValue.count > 0 ? currentValue.key : accumulator;
      }, null);

      let historyData = {
        historyLoading: false,
        historySum: historySum,
        historyResources: definedResources,
        historyActiveKey
      };

      if (historySum !== 0) {
        historyData = { ...historyData, historyShow: true, historyNoDataHint: false };
      } else {
        historyData = { ...historyData, historyShow: false, historyNoDataHint: true };
      }
      this.setState(historyData);
    });
  };

  handleTableChange = (key, pagination, filters, sorter) => {
    const { current: page } = pagination;
    const sorterVal = pick(sorter, ['field', 'order']);
    sorterVal.order = sorterVal.order === 'descend' ? 'DESC' : 'ASC';
    this.setState({ sorters: { ...this.state.sorters, [key]: sorterVal } }, () => {
      this.loadHistory([key], page);
    });
  };

  confirmManage = () => {
    api('confirmMaintenances', this.state.selectedMaintenance)
      .then(maintenanceSummary => {
        if (this.state.checkedNewMaintenance) {
          this.setState({ showModalAddInManage: true });
        }
        this.props.onConfirmMaintenances();
        this.setState({ maintenanceSummary, showManageModal: false, selectedMaintenance: null });
      })
      .catch(() => {
        this.setState({ showManageModal: false, selectedMaintenance: null, showModalAddInManage: false });
      });
  };

  resetModal = () => {
    this.setState({
      modalAddLoading: true,
      modalCanAdd: true,
      modalAddDescription: null,
      modalAddKm: null,
      modalAddMoment: null,
      modalAddDate: null
    });
  };

  onChange = () => {
    this.setState({
      checkedNewMaintenance: true
    });
  };

  render() {
    const { translationsStore } = this.props;
    const { sorters, historyActiveKey } = this.state;
    const columns = this.historyTableColumns.map(column => {
      let sortOrder = (sorters[historyActiveKey] || {}).field === column.dataIndex ? sorters[historyActiveKey].order : false;
      sortOrder = sortOrder === 'DESC' ? 'descend' : sortOrder === 'ASC' ? 'ascend' : false;
      return {
        ...column,
        sortOrder
      };
    });
    return (
      <Card className="MaintenanceCard" style={this.props.style} id="MaintenanceCard">
        <div className="header">
          <div style={{ display: 'flex' }}>
            <div>{translationsStore.translate('carView.MaintenanceCard.title')}</div>
            <div style={{ marginLeft: 20 }}>
              <NewMaintenanceModal
                carId={this.props.carId}
                visible={this.state.showModalAdd}
                onCancel={() => this.setState({ showModalAdd: false })}
                onOk={() => {
                  this.setState({ showModalAdd: false });
                }}
              />
              <Button
                onClick={() => {
                  this.setState({ showModalAdd: true });
                }}
                type="primary"
              >
                {translationsStore.translate('carView.MaintenanceCard.createNew.labelCreate')}
              </Button>
            </div>
          </div>
          <Popover
            content={translationsStore.translate('carView.MaintenanceCard.historyNoData.message')}
            title={translationsStore.translate('carView.MaintenanceCard.historyNoData.title')}
            trigger="click"
            visible={this.state.historySum === 0 && this.state.historyNoDataHint}
            onVisibleChange={visible => this.setState({ historyNoDataHint: visible })}
          >
            <Button onClick={() => this.loadHistory()} type="primary">
              {translationsStore.translate('carView.history')}
            </Button>
          </Popover>
        </div>
        <Table pagination={false} dataSource={this.props.maintenances} columns={this.columns} rowKey={record => record.id} />
        {!!this.props.othermaintenances && this.props.othermaintenances.length > 0 && (
          <div onClick={() => this.setState({ showothers: true })} style={{ marginTop: '10px', cursor: 'pointer', textDecoration: 'underline', fontWeight: 'bold' }}>
            {this.props.othermaintenances.length} {translationsStore.translate('carView.MaintenanceCard.othermaintenances.message')}
          </div>
        )}
        <Modal
          title={translationsStore.translate('carView.MaintenanceCard.othermaintenances.title')}
          width="calc(var(--tablet-width) / var(--modal-width-ratio))"
          visible={this.state.showothers}
          getContainer={() => document.getElementById('MaintenanceCard')}
          footer={null}
          onCancel={() => this.setState({ showothers: false })}
          centered={true}
        >
          <Table pagination={false} columns={this.columns} dataSource={this.props.othermaintenances} rowKey={record => record.id} />
        </Modal>
        <Modal
          title={translationsStore.translate('carView.MaintenanceCard.history.title')}
          width="calc(var(--tablet-width) / var(--modal-width-ratio))"
          visible={this.state.historyShow}
          getContainer={() => document.getElementById('MaintenanceCard')}
          footer={null}
          onCancel={() => this.setState({ historyShow: false })}
          centered={true}
        >
          <Spin spinning={this.state.historyLoading}>
            {(this.state.historyResources || []).map(
              (item, index) =>
                item.count > 0 &&
                item.key === this.state.historyActiveKey && (
                  <Table
                    id="MaintenanceCardHistory"
                    key={index}
                    dataSource={this.state.historyResources[index] && this.state.historyResources[index].dataSource}
                    columns={columns}
                    pagination={item.pagination}
                    onChange={(...params) => this.handleTableChange(item.key, ...params)}
                    rowClassName="historyRow"
                  />
                )
            )}
          </Spin>
        </Modal>
        <Modal
          title={translationsStore.translate('carView.MaintenanceCard.confirm.title')}
          visible={this.state.showManageModal}
          footer={null}
          onCancel={() => this.setState({ showManageModal: false, checkedNewMaintenance: false, selectedMaintenance: null })}
        >
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <Checkbox onChange={this.onChange} checked={this.state.checkedNewMaintenance}>
              {translationsStore.translate('carView.MaintenanceCard.confirm.labelCreateAnotherOne')}
            </Checkbox>
            <span>
              <Button type="primary" size="small" className="confirm" onClick={this.confirmManage}>
                OK
              </Button>
            </span>
          </div>
        </Modal>
        <NewMaintenanceModal
          carId={this.props.carId}
          visible={this.state.showModalAddInManage}
          onCancel={() => this.setState({ showModalAddInManage: false, checkedNewMaintenance: false })}
          onOk={() => {
            this.setState({ showModalAddInManage: false, checkedNewMaintenance: false });
          }}
        />
      </Card>
    );
  }
}
